import { useEffect, useRef, useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { EffectCards } from "swiper/modules"

import EIDComponent from "../components/eID.component"
import { useEID } from "../hooks/useEID"
import EIDDetailsDialogComponent from "../dialogs/eID-details-dialog.componen"

const EIDListComponent = ({user_id}) => {

    const {isLoadingGetEIDList, eids, errorGetEIDList, getEIDListByUser, isLoadingGetEIDInfoQRCode, eidInfQRCode, errorGetEIDInfoQRCode, getEIDInfoQRCode} = useEID()
    const [eIDList, setEIDList] = useState([])
    const [imgSrc, setImgSrc] = useState(null)

    const [openEIDDetailsDialog, setOpenEIDDetailsDialog] = useState(false)
    const [eIDDetails, setEIDDetails] = useState(null)
    const [eIDQRCode, setEIDQRCode] = useState(null)

    const ref = useRef(null);

    useEffect(() => {
        if (user_id) {
            getEIDListByUser(user_id)
            getEIDInfoQRCode(user_id)
        }
    }, [user_id])

    useEffect(() => {
        if (eids) {
            let testArr = eids
            // setEIDList([...testArr, ...eids])
            setEIDList(eids)
        }
    }, [JSON.stringify(eids)])

    useEffect(() => {
        if (eidInfQRCode) {
            setEIDQRCode(eidInfQRCode.baseURL)
        }
    }, [JSON.stringify(eidInfQRCode)])

    const downloadImage = () => {
        // if (ref.current) {
        //     toPng(ref.current).then((dataUrl) => {
        //         setImgSrc(dataUrl);
        //     });
        // }
        // if (ref.current === null) return;

        // toPng(ref.current)
        // .then((dataUrl) => {
        //     const link = document.createElement('a');
        //     link.download = 'id-card.png';
        //     link.href = dataUrl;
        //     link.click();
        // })
        // .catch((err) => {
        //     console.error('Failed to generate image:', err);
        // });
    };

    const handleOpenEIDDetailsDialog = (eIDDetails) => {
        console.log("test open dialog bbb");
        setEIDDetails(eIDDetails)
        setOpenEIDDetailsDialog(true)
    }

    const handleCloseEIDDetailsDialog = () => {
        setOpenEIDDetailsDialog(false)
    }

    return(
        <>
            <Swiper
                effect={'cards'}
                grabCursor={true}
                modules={[EffectCards]}
                className="mySwiper"
                style={{width: '100%', maxWidth: 640, borderRadius: 15}}
            >
                {
                    (eIDList.length > 0 && eIDQRCode) &&
                    eIDList.map((item) => {
                        return(
                            <>
                                <SwiperSlide onClick={() => handleOpenEIDDetailsDialog(item)}>
                                    <EIDComponent ref={ref} details={item} eIDQRCode={eIDQRCode} />
                                </SwiperSlide>
                            </>
                        )
                    })
                }
            </Swiper>

            {
                openEIDDetailsDialog &&
                <EIDDetailsDialogComponent open={openEIDDetailsDialog} handleClose={handleCloseEIDDetailsDialog} details={eIDDetails} eIDQRCode={eIDQRCode} />
            }
        </>
    )
}

export default EIDListComponent